import { render, staticRenderFns } from "./Capacidad.vue?vue&type=template&id=31ba9e00&scoped=true"
import script from "./Capacidad.vue?vue&type=script&lang=js"
export * from "./Capacidad.vue?vue&type=script&lang=js"
import style0 from "./Capacidad.vue?vue&type=style&index=0&id=31ba9e00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ba9e00",
  null
  
)

export default component.exports